module.exports = __webpack_public_path__ + "assets/img/7365b0eb725eecf128a9df3b9f4b6e27.png";